const t = (key, fallback = '') => (window.BL_I18N && BL_I18N[key]) || fallback || key;
const CURRENT_LOCALE = (window.BL_I18N && BL_I18N.locale) || document.documentElement.lang || 'en-US';

class ConfirmationApi {
    constructor() {
        this.$loader  = $('#booking-loader');
        this.$content = $('#confirmation-content');
        this.$error   = $('#booking-error');

        this.$codeHost  = $('[data-role="confirmation-code"]');
        this.$unitHost  = $('[data-role="apartment-detail"]');
        this.$bdHost    = $('[data-role="booking-details"]');
        this.$priceHost = $('[data-role="price-breakdown"]');
        this.$cancelHost = $('[data-role="cancel-booking"]');

        this.currency = window.BL_CURRENCY || 'CHF';
        this.locale   = window.BL_LOCALE   || 'de-CH';
        this.bookingId = this.getParam('bookingId');
        this.code = (window.BL_AJAX && BL_AJAX.confirmation_code) || '';
        this.ref = this.getParam('ref');
        this.apartmentName = '';

        const ajax = window.BL_AJAX || {};
        this.emailSupport = ajax.email_support || null;
        this.phoneSupport = ajax.phone_support || null;

        this.boot();
    }

    /* ------------ utils ------------ */
    getParam(k){ try{ return new URLSearchParams(location.search).get(k) || ''; }catch{ return '';} }
    showLoader(){ this.$loader.removeClass('hidden'); this.$content.addClass('hidden'); this.$error.addClass('hidden'); }
    showContent(){ this.$loader.addClass('hidden'); this.$error.addClass('hidden'); this.$content.removeClass('hidden'); }
    showError(msg){
        this.$loader.addClass('hidden');
        this.$error.text(msg || t('booking_not_found','Booking not found.')).removeClass('hidden');
        this.$content.addClass('hidden');
    }
    esc(s){ return String(s||'').replace(/[&<>"']/g,m=>({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m])); }
    money(n){ const v=Number(n)||0;
        try{ return new Intl.NumberFormat(this.locale,{style:'currency',currency:this.currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(v); }
        catch{ return `${this.currency} ${v.toFixed(2)}`; } }
    round1(x){ const n=Number(x); return Number.isFinite(n) ? Math.round(n*10)/10 : 0; }
    nights(ci,co){ if(!ci||!co) return 0;
        const a=new Date(ci), b=new Date(co);
        const ms=Date.UTC(b.getUTCFullYear(),b.getUTCMonth(),b.getUTCDate())-Date.UTC(a.getUTCFullYear(),a.getUTCMonth(),a.getUTCDate());
        return Math.max(0,Math.floor(ms/86400000)); }
    fmtDateTime(iso){
        if(!iso) return '';
        const d=new Date(iso); if(isNaN(d)) return iso;
        try{
            const date=new Intl.DateTimeFormat('en-GB',{weekday:'short', day:'2-digit', month:'long'}).format(d);
            const time=new Intl.DateTimeFormat('en-GB',{hour:'2-digit', minute:'2-digit'}).format(d);
            // return `${date}, ${time}`;
            return `${date}`;
        }catch{ return iso; }
    }

    fmtDateLocal(iso, locale = CURRENT_LOCALE) {
        if (!iso) return '';
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
        if (!m) return iso;

        const [, y, mo, d] = m;
        const dt = new Date(Date.UTC(+y, +mo - 1, +d));

        const now = new Date();
        const sameYear = dt.getUTCFullYear() === now.getUTCFullYear();

        const safeLocale = String(locale || '').trim().replace(/_/g, '-');

        const opts = { weekday: 'short', day: 'numeric', month: 'long', timeZone: 'UTC' };
        if (!sameYear) opts.year = 'numeric';

        try {
            return new Intl.DateTimeFormat(safeLocale, opts).format(dt);
        } catch {
            const mon = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            return `${['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][dt.getUTCDay()]} ${+d} ${mon[dt.getUTCMonth()]}` + (sameYear ? '' : ` ${dt.getUTCFullYear()}`);
        }
    }

    fmtTimeTuple(tuple, locale = CURRENT_LOCALE) {
        // підтримує: [h, m], "HH:mm", "HH:mm:ss"
        let h = 0, m = 0;
        if (Array.isArray(tuple)) {
            h = Number(tuple[0]) || 0;
            m = Number(tuple[1] ?? 0) || 0;
        } else if (typeof tuple === 'string') {
            const mm = tuple.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
            if (mm) { h = Number(mm[1]) || 0; m = Number(mm[2]) || 0; }
        } else if (tuple && typeof tuple === 'object' && 'hours' in tuple) {
            h = Number(tuple.hours) || 0;
            m = Number(tuple.minutes || 0) || 0;
        } else {
            return '';
        }

        const tmp = new Date(Date.UTC(1970, 0, 1, h, m));
        try {
            return new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(tmp);
        } catch {
            return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}`;
        }
    }

    escapeHtml(value) {
        const str = value == null ? '' : String(value);
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '`': '&#96;',
        };
        return str.replace(/[&<>"'`]/g, ch => map[ch]);
    }

    arrDateToIso(v) {
        if (!v) return '';
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) return v;

        const m = typeof v === 'string' && v.match(/Date\((\d+)\)/);
        if (m) {
            const d = new Date(Number(m[1]));
            return isNaN(d) ? '' : d.toISOString().slice(0, 10);
        }

        const d = new Date(v);
        return isNaN(d) ? '' : d.toISOString().slice(0, 10);
    }

    pickStay(payload){
        const list = payload?.roomStays?.content || [];
        if (!list.length) return null;

        const prio = { CHECKED_IN: 3, CONFIRMED: 2, CHECKED_OUT: 1 };
        const toTs = (arr)=> {
            if (!Array.isArray(arr) || arr.length<3) return 0;
            const [y,m,d] = arr;
            return Date.parse(`${y}-${String(m).padStart(2,'0')}-${String(d).padStart(2,'0')}T00:00:00Z`) || 0;
        };

        // відсортуємо за пріоритетом і найсвіжішою startDate
        const sorted = [...list].sort((a,b)=>{
            const pa = prio[a.roomStayStatus] || 0;
            const pb = prio[b.roomStayStatus] || 0;
            if (pa !== pb) return pb - pa;
            return (toTs(b.startDate) - toTs(a.startDate));
        });

        // якщо перший CANCELLED (рідко), знайдемо перший не-CANCELLED
        const found = sorted.find(s => s.roomStayStatus !== 'CANCELLED') || sorted[0];
        return found || null;
    }

    // перетворює [YYYY, M, D] -> 'YYYY-MM-DD'
    toYMD(arr){
        if (!Array.isArray(arr) || arr.length < 3) return '';
        const [y,m,d] = arr;
        const pad = (n)=> String(n).padStart(2,'0');
        return `${y}-${pad(m)}-${pad(d)}`;
    }

// обирає джерело дати: спершу chosenStay (як Y-M-D), далі booking.*, і відрізає час
    pickStayDate(payload, key /* 'start' | 'end' */){
        const cs = payload?.chosenStay;
        if (cs && Array.isArray(cs[ key === 'start' ? 'startDate' : 'endDate' ])) {
            return this.toYMD(cs[ key === 'start' ? 'startDate' : 'endDate' ]);
        }
        const bk = payload?.booking || {};
        const raw = key === 'start' ? (bk.dateFrom || '') : (bk.dateTo || '');
        return raw ? String(raw).slice(0,10) : '';
    }

    getSafeEmail(data) {
        const b = data?.booking || {};
        // спочатку беремо те, що вже вивели в кнопці, якщо є
        const fromBtn = $('#js-resend-email').attr('data-role-resend-email');
        return (fromBtn
            || b?.bookingAccount?.contact?.emailAddress
            || b?.primaryGuest?.email
            || b?.email
            || '').trim();
    }

    getStayDates(data) {
        const b = data?.booking || {};
        const ch = data?.chosenStay || {};
        // формуємо YYYY-MM-DD (приймається як plain текст у листі)
        const arrToIso = (arr) => Array.isArray(arr) && arr.length>=3
            ? `${arr[0]}-${String(arr[1]).padStart(2,'0')}-${String(arr[2]).padStart(2,'0')}` : '';

        const df = b.dateFrom || arrToIso(ch.startDate) || '';
        const dt = b.dateTo   || arrToIso(ch.endDate)   || '';
        return { dateFrom: df, dateTo: dt };
    }

    getGuests(data) {
        const b = data?.booking || {};
        const ch = data?.chosenStay || {};
        return Number(b.adults ?? b.guests ?? ch.numberOfAdults) || '';
    }

    getUnitTitle(data) {
        const a = data?.apartment || data?.unit || {};
        return a.title || a.unitTypeName || a.unitName || '';
    }

    /* ------------ data ------------ */
    fetchBooking(){
        const ajaxUrl=(window.BL_AJAX&&BL_AJAX.url)||'/wp-admin/admin-ajax.php';
        const nonce  =(window.BL_AJAX&&BL_AJAX.nonce)||'';

        return $.ajax({
            url: ajaxUrl, method:'POST', dataType:'json',
            data: { action:'bl_get_booking_details', _ajax_nonce:nonce, bookingReference: this.code, ref: this.ref }
        }).then(res=>{
            if(!res?.success) return Promise.reject(new Error(res?.data?.message||'Failed to load booking'));
            return res.data||{};
        });
    }

    /* ---- price model з roomStays[0] ---- */
    computePriceModel(payload){
        const bk = payload?.booking || {};

        // дати для підрахунку ночей
        const stay = payload?.chosenStay || this.pickStay(payload) || {};
        const ciIso = this.arrDateToIso(stay.startDate) || payload?.booking?.dateFrom || '';
        const coIso = this.arrDateToIso(stay.endDate)   || payload?.booking?.dateTo || '';
        const nights = this.nights(ciIso, coIso);

        // БЕРЕМО ЛИШЕ З BOOKING
        const net  = Number(bk.bookingNet || 0);           // сума за проживання (поруч з nights)
        const vat  = Number(bk.bookingVat || 0);           // VAT
        const vatRate = net > 0 ? (vat / net) : 0;         // для відсотка в дужках

        const extrasNet = Number(bk.bookingExtrasNet || 0) + Number(bk.bookingExtrasVat || 0);          // Extra services
        const commission = Number(bk.commissionFeeToAgent || 0);     // Commission fee to agent

        // Total = все, що показуємо вище
        const total = net + vat + extrasNet + commission;

        return {
            nights,
            bookingNet: net,
            vatAmount: vat,
            vatRate,
            extrasNet,
            commission,
            totalGross: total
        };
    }


    /* ------------ render blocks ------------ */
    renderCancelButton(chosenStay, booking){
        const status = String(chosenStay?.roomStayStatus || '');
        // показуємо кнопку лише якщо не CHECKED_OUT
        if (status === 'CHECKED_OUT') {
            this.$cancelHost.empty();
            return;
        }

        const html = `
          <button id="js-cancel-booking" class="text-red-600 hover:text-red-700 text-sm underline font-medium">
            ${t('cancel_booking_cta','I want to cancel my booking')}
          </button>
        `;
        this.$cancelHost.html(html);

        const code = this.safeConfirmationCode(booking);
        $('#js-cancel-booking').off('click').on('click', (e)=>{
            e.preventDefault();
            this.openCancelModal(code);
        });
    }

    safeConfirmationCode(booking){
        // підстав що є
        return String(
            booking?.confirmationCode ||
            booking?.bookingReference ||
            booking?.webReference ||
            booking?.id || ''
        );
    }

    openCancelModal(confirmationCode){
        // уникаємо дубля
        this.closeCancelModal();

        const email = this.emailSupport || {};
        const phone = this.phoneSupport || {};

        const subjectLang = t('booking_cancellation_request', 'Booking Cancellation Request');
        const subject = encodeURIComponent(`${subjectLang} - ${confirmationCode}`);

        const emailBlock = (email && email.url) ? `
          <a class="flex items-center gap-3 p-3 border rounded-lg" href="mailto:support@basellodging.ch?subject=${subject}" target="${this.escapeHtml(email.target || '_self')}">
            <svg xmlns="http://www.w3.org/2000/svg" class="lucide lucide-mail w-5 h-5 text-basel-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect width="20" height="16" x="2" y="4" rx="2"></rect>
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
            </svg>
            <div>
              <div class="font-medium">${t('email_support_now','Email Support Now')}</div>
                ${this.escapeHtml(email.title)? `<div class="text-sm text-basel-blue hover:text-basel-blue-dark">
                 ${this.escapeHtml(email.title)}
              </div>`:''}
              
            </div>
          </a>
        ` : '';

        const phoneBlock = (phone && phone.url) ? `
          <a class="flex items-center gap-3 p-3 border rounded-lg" href="${this.escapeHtml(phone.url)}" target="${this.escapeHtml(phone.target || '_self')}">
            <svg xmlns="http://www.w3.org/2000/svg" class="lucide lucide-phone w-5 h-5 text-basel-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            <div>
              <div class="font-medium">${t('phone_support','Phone Support')}</div>
              ${this.escapeHtml(phone.title)? `<div class="text-sm text-basel-blue hover:text-basel-blue-dark">
                 ${this.escapeHtml(phone.title)}
              </div>`:''}
            </div>
          </a>
        ` : '';

        const mid = `cancel-${Math.random().toString(36).slice(2,9)}`;
        const overlay = document.createElement('div');
        overlay.className = 'fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0';
        overlay.setAttribute('data-state','open');
        overlay.setAttribute('aria-hidden','true');
        overlay.style.pointerEvents = 'auto';
        overlay.id = `${mid}-overlay`;

        const dialog = document.createElement('div');
        dialog.id = `${mid}-dialog`;
        dialog.setAttribute('role','dialog');
        dialog.setAttribute('aria-labelledby', `${mid}-title`);
        dialog.setAttribute('aria-describedby', `${mid}-desc`);
        dialog.setAttribute('data-state','open');
        dialog.tabIndex = -1;
        dialog.className = 'fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg sm:max-w-md';
        dialog.style.pointerEvents = 'auto';

        dialog.innerHTML = `
          <div class="flex flex-col space-y-1.5 text-center sm:text-left">
            <h2 id="${mid}-title" class="text-lg font-semibold leading-none tracking-tight flex items-center gap-2 text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" class="lucide lucide-triangle-alert w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>
              ${t('cancel_booking_title','Cancel Booking')}
            </h2>
            <p id="${mid}-desc" class="text-sm text-muted-foreground">
              ${t('cancel_booking_desc',"We're sorry to see you go. Please contact our support team to cancel your booking.")}
            </p>
          </div>
        
          <div class="space-y-4">
            <div role="alert" class="relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground bg-background text-foreground">
              <svg xmlns="http://www.w3.org/2000/svg" class="lucide lucide-triangle-alert h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>
              <div class="text-sm">${t('have_code_ready','Please have your confirmation code <strong>%s</strong> ready when contacting support.').replace('%s', this.esc(confirmationCode))}</div>
            </div>
        
            <div class="space-y-3">
               ${emailBlock}
               ${phoneBlock}
            </div>
          </div>
        
          <div class="flex sm:justify-end flex-col sm:flex-col space-y-2">
            <button id="${mid}-keep" class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full">
              ${t('keep_my_booking','Keep My Booking')}
            </button>
          </div>
        
          <button type="button" id="${mid}-close"
            class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="lucide lucide-x h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
            <span class="sr-only">${t('close','Close')}</span>
          </button>
        `;

        document.body.appendChild(overlay);
        document.body.appendChild(dialog);

        // закриття
        const close = ()=> this.closeCancelModal();
        overlay.addEventListener('click', close);
        document.getElementById(`${mid}-close`)?.addEventListener('click', close);
        document.getElementById(`${mid}-keep`)?.addEventListener('click', close);

        // ESC
        const escHandler = (ev)=>{ if(ev.key==='Escape') close(); };
        document.addEventListener('keydown', escHandler, { once:true });

        // фокус
        setTimeout(()=> dialog.focus(), 0);

        // запам’ятаємо id щоб прибрати все
        this._cancelModalIds = { mid, escHandler };
    }

    closeCancelModal(){
        const ids = this._cancelModalIds;
        if (!ids) return;
        document.removeEventListener('keydown', ids.escHandler);
        document.getElementById(`${ids.mid}-overlay`)?.remove();
        document.getElementById(`${ids.mid}-dialog`)?.remove();
        this._cancelModalIds = null;
    }

    renderConfirmationBlock(booking, chosenStay){
        const code =
            booking?.confirmationCode ||
            booking?.bookingReference ||
            booking?.webReference ||
            String(booking?.id || '—');

        // email: ResH різні місця
        const email =
            chosenStay?.billingAccount?.contact?.emailAddress ||
            booking?.billingAccount?.contact?.emailAddress ||
            '';

        const html = `
        <div class="rounded-lg text-card-foreground shadow-sm border border-gray-200 bg-white">
          <div class="p-6 pt-6 pb-6">
            <div class="flex items-center justify-between mb-6">
              <div>
                <div class="text-sm text-gray-600">${t('confirmation_code','Confirmation Code')}</div>
                <div class="text-2xl font-bold text-basel-gray">${this.esc(code)}</div>
              </div>
              <div class="text-right">
                <div class="text-xs text-gray-500">${t('save_this_code','Please save this code')}</div>
                <div class="text-xs text-gray-500">${t('for_future_reference','for future reference')}</div>
              </div>
            </div>
            <div class="space-y-4">
              <div class="flex items-start gap-3">
                <div class="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg>
                </div>
                ${email? `<div class="flex-1">
                  <div class="text-basel-gray">${t('confirmation_email_sent_to','Confirmation email sent to')} <span class="font-medium">${this.esc(email)}</span></div>
                  <button id="js-resend-email" class="text-basel-blue hover:text-basel-blue-dark underline text-sm mt-1 inline-flex items-center gap-1" data-resend-email="${this.esc(email)}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"/><path d="m21.854 2.147-10.94 10.939"/></svg>
                    ${t('resend_email','Resend email')}
                  </button>
                </div>`: ''}
              </div>
            </div>
          </div>
        </div>`;
        this.$codeHost.html(html);
    }

    renderApartmentDetailBlock(apartment){
        const title   = apartment?.title || apartment?.unitTypeName || t('apartment','Apartment');
        const address = apartment?.areaName && apartment?.city ?  apartment?.areaName +', '+ apartment?.city : '';
        const areaMin = apartment?.specifications?.area?.min;
        const areaMax = apartment?.specifications?.area?.max;
        const area    = (areaMin && areaMax && areaMin!==areaMax) ? `${areaMin}–${areaMax}m²`
            : (areaMin || areaMax) ? `${areaMin || areaMax}m²` : '';
        const guests  = apartment?.specifications?.maxOccupancy || apartment?.maxGuests || '';
        const bedrooms= apartment?.specifications?.numberOfBedrooms ?? apartment?.bedrooms;
        const bedsTxt = (bedrooms!=null)
            ? (Number(bedrooms)===0 ? t('studio','Studio')
                : `${bedrooms} ${Number(bedrooms)===1 ? t('bed','bed') : t('beds','beds')}`)
            : '';
        const baths = (apartment?.bathrooms!=null)
            ? `${apartment.bathrooms} ${Number(apartment.bathrooms)===1 ? t('bath','bath') : t('baths','baths')}`
            : '';
        const img     = apartment?.mainImage?.url || (apartment?.images?.[0] || '/placeholder.svg');

        const html = `
        <div class="rounded-lg bg-card text-card-foreground shadow-sm border border-gray-200">
          <div class="p-6 pt-6">
            <div class="flex flex-col sm:flex-row gap-4">
              <div class="flex-shrink-0">
                <img src="${this.esc(img)}" alt="${this.esc(title)}" class="w-full sm:w-24 h-32 sm:h-24 object-cover rounded-lg">
              </div>
              <div class="flex-1">
                <h3 class="font-semibold text-basel-gray mb-2">${this.esc(title)}</h3>
                <div class="flex items-center text-sm text-gray-600 mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg>
                  ${this.esc(address)}
                </div>
                <div class="flex items-center gap-4 text-sm text-basel-gray">
                  ${area ? `<div class="flex items-center gap-1"><svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-basel-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect width="18" height="18" x="3" y="3" rx="2"/></svg><span>${this.esc(area)}</span></div>` : ''}
                  ${guests ? `<div class="flex items-center gap-1"><svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-basel-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg><span>${guests} ${guests > 1 ? t('guests','Guests').toLowerCase():t('guest','Guest').toLowerCase()}</span></div>` : ''}
                  ${bedsTxt ? `<div class="flex items-center gap-1"><svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-basel-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 4v16"/><path d="M2 8h18a2 2 0 0 1 2 2v10"/><path d="M2 17h20"/><path d="M6 8v9"/></svg><span>${this.esc(bedsTxt)}</span></div>` : ''}
                  ${baths ? `<div class="flex items-center gap-1"><svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-basel-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 4 8 6"/><path d="M17 19v2"/><path d="M2 12h20"/><path d="M7 19v2"/><path d="M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/></svg><span>${this.esc(baths)}</span></div>` : ''}
                </div>
              </div>
            </div>
          </div>
        </div>`;
        this.$unitHost.html(html);
    }

    renderBookingDetailsBlock(payload){
        const stay = payload?.chosenStay || this.pickStay(payload) || {};
        const ciIso = this.arrDateToIso(stay.startDate) || payload?.booking?.dateFrom || '';
        const coIso = this.arrDateToIso(stay.endDate)   || payload?.booking?.dateTo || '';
        const nights = this.nights(ciIso, coIso);
        const ciLabel = this.fmtDateLocal(ciIso, CURRENT_LOCALE);
        const coLabel = this.fmtDateLocal(coIso, CURRENT_LOCALE);

        const ciTime = this.fmtTimeTuple(stay.estimatedArrivalTime,   CURRENT_LOCALE);
        const coTime = this.fmtTimeTuple(stay.estimatedDepartureTime, CURRENT_LOCALE);

        const ciLabelFull = [ciLabel, ciTime].filter(Boolean).join(', ');
        const coLabelFull = [coLabel, coTime].filter(Boolean).join(', ');

        const html = `
        <div class="rounded-lg bg-card text-card-foreground shadow-sm border border-gray-200">
          <div class="flex flex-col space-y-1.5 p-6 border-b border-gray-100">
            <h3 class="tracking-tight text-lg font-semibold text-basel-gray">${t('booking_details','Booking Details')}</h3>
          </div>
          <div class="p-6 pt-6">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <div class="text-sm text-gray-600 mb-1">${t('arrival','Arrival Date')}</div>
                <div class="font-bold text-basel-gray flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-basel-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/></svg>
                  ${this.esc(ciLabelFull)}
                </div>
              </div>
              <div>
                <div class="text-sm text-gray-600 mb-1">${t('departure','Departure Date')}</div>
                <div class="font-bold text-basel-gray flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-basel-blue" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/></svg>
                  ${this.esc(coLabelFull)}
                </div>
              </div>
            </div>
            <div class="mt-4 pt-4 border-t border-gray-100">
              <div class="text-sm text-gray-600">${t('total_length_of_stay','Total length of stay')}</div>
              <div class="font-bold text-basel-gray">${nights} ${nights===1 ? t('night','night') : t('nights','nights')}</div>
            </div>
          </div>
        </div>`;
        this.$bdHost.html(html);
    }

    renderPriceBreakdownBlock(price, extras = []){
        const rows = [];
        const GUEST_TAX_CHF = 4.20;

        // 1) Nights row (сума = bookingNet)
        if (price.nights > 0) {
            rows.push(`
              <div class="flex justify-between text-sm text-basel-gray">
                <span>${price.nights} ${price.nights>1 ? t('nights','nights') : t('night','night')}</span>
                <span>${this.money(price.bookingNet || 0)}</span>
              </div>
            `);
        }

        // 2) VAT row (з відсотком від bookingNet)
        if (price.vatAmount > 0) {
            const pct = this.round1((price.vatRate || 0) * 100);
            rows.push(`
              <div class="flex justify-between text-sm text-basel-gray">
                <span>${t('vat','VAT')} (${pct}%)</span>
                <span>${this.money(price.vatAmount)}</span>
              </div>
            `);
        }

        // // 3) Chargeable extras: показуємо кожен окремо (one-off), без множення
        // const chargeableExtras = Array.isArray(extras) && extras.length
        //     ? extras
        //     : (Array.isArray(this.lastPayload?.chargeableExtras) ? this.lastPayload.chargeableExtras : []);
        //
        // if (chargeableExtras.length) {
        //     chargeableExtras.forEach(x => {
        //         const label = x?.description || x?.product?.name || 'Extra';
        //         const amount = Number(x?.netPrice || 0);
        //         rows.push(`
        //           <div class="flex justify-between text-sm text-basel-gray">
        //             <span>${this.esc(label)}</span>
        //             <span>${this.money(amount)}</span>
        //           </div>
        //         `);
        //     });
        // }
        //
        // const chargeableExtrasSum = chargeableExtras.reduce((s, x) => s + Number(x?.netPrice || 0), 0);

        // 4) Extra services (якщо > 0)
        if (price.extrasNet > 0) {
            rows.push(`
              <div class="flex justify-between text-sm text-basel-gray">
                <span>${t('extra_services', 'Extra services')}:</span>
                <span>${this.money(price.extrasNet)}</span>
              </div>
            `);
        }

        // 4) Commission fee to agent — ПЕРЕД total (якщо > 0)
        let commissionRow = '';
        if (price.commission > 0) {
            commissionRow = `
              <div class="flex justify-between text-sm text-basel-gray">
                <span>${t('commission_fee_to_agent','Commission fee to agent')}</span>
                <span>${this.money(price.commission)}</span>
              </div>
            `;
        }

        const html = `
        <div class="rounded-lg bg-card text-card-foreground shadow-lg border border-gray-200">
          <div class="flex flex-col space-y-1.5 p-6 border-b border-gray-100">
            <h3 class="tracking-tight text-lg font-semibold text-basel-gray">${t('price_breakdown','Price Breakdown')}</h3>
          </div>
          <div class="p-6 pt-6 space-y-4">
            <div class="space-y-3">
              ${rows.join('')}
              ${commissionRow}
            </div>
            <div class="shrink-0 bg-border h-[1px] w-full my-4"></div>
            <div class="flex justify-between font-bold text-xl text-basel-gray">
              <span>${t('total_paid','Total paid')}</span>
              <span>${this.money(price.totalGross || 0)}</span>
            </div>
          </div>
        </div>`;
        this.$priceHost.html(html);
    }

    bindResendEmail(data) {
        const $btn = $('#js-resend-email');
        if (!$btn.length) return;

        $btn.off('click.resend').on('click.resend', (e) => {
            e.preventDefault();

            const email = $(e.target).data('resend-email') || '';

            if (!email) { alert(t('no_recipient_email','No recipient email is set.')); return; }

            const ajaxUrl = (window.BL_AJAX && BL_AJAX.url) || '/wp-admin/admin-ajax.php';
            const nonce   = (window.BL_AJAX && BL_AJAX.nonce) || '';

            const booking  = data?.booking || {};
            const { dateFrom, dateTo } = this.getStayDates(data);
            const guests   = this.getGuests(data);
            const unitTitle= this.getUnitTitle(data);
            const extrasNet = Number(booking.bookingExtrasNet || 0) + Number(booking.bookingExtrasVat || 0);
            const net  = Number(booking.bookingNet || 0);           // сума за проживання (поруч з nights)
            const vat  = Number(booking.bookingVat || 0);   // Extra services
            const commission = Number(booking.commissionFeeToAgent || 0);
            const total = net + vat + extrasNet + commission;
            const firstName = booking.bookingAccount.contact.firstName || booking.billingAccount.contact.firstName || booking.bookingContact.firstName || booking.billingContact.firstName
            const lastName = booking.bookingAccount.contact.lastName || booking.billingAccount.contact.lastName || booking.bookingContact.lastName || booking.billingContact.lastName
            const name = firstName +' '+lastName;
            const unitLocation =  data?.apartment.addressLine1 + ', ' + data?.apartment.areaName + ', ' + data?.apartment.city;

            const payload = {
                email,
                bookingIdentifier: String(booking.id || ''),
                bookingReference:  String(booking.bookingReference || ''),
                unitTitle,
                unitLocation,
                dateFrom, dateTo,
                guests,
                total,
                name,
                message: '',
                lang: (window.BL_AJAX && BL_AJAX.lang) || ''
            };

            console.log(payload);

            // UX: disable
            const orig = $btn.text();
            $btn.prop('disabled', true).text(t('sending','Sending…'));

            $.ajax({
                url: ajaxUrl,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'bl_send_booking_emails',
                    _ajax_nonce: nonce,
                    data: JSON.stringify(payload)
                }
            })
                .done((res) => {
                    // короткий тост
                    $btn.text(t('sent','Sent ✔'));
                    setTimeout(() => $btn.text(orig), 1600);
                })
                .fail((xhr) => {
                    alert(xhr?.responseJSON?.message || t('failed_resend_email','Failed to resend email.'));
                    $btn.text(orig);
                })
                .always(() => {
                    $btn.prop('disabled', false);
                });
        });
    }


    async boot(){
        if (!this.code || !this.ref) { this.showError(t('required_param_missing','Required parameter is missing.')); return; }
        this.showLoader();
        try{
            const data  = await this.fetchBooking();      // { booking, roomStays:{content:[]}, apartment, chosenStay? }
            const price = this.computePriceModel(data);
            const stays = (data?.roomStays?.content || []);
            const chosenStay = stays.length ? stays[stays.length - 1] : null;

            this.apartmentName = data.apartment.title || '';

            this.renderConfirmationBlock(data.booking, chosenStay);
            this.renderApartmentDetailBlock(data.apartment);
            this.renderBookingDetailsBlock(data);
            this.renderPriceBreakdownBlock(price, data?.chargeableExtras || []);
            this.renderCancelButton(data.chosenStay, data.booking);

            this.bindResendEmail(data);
            this.showContent();
        }catch(e){
            this.showError(e?.message || t('failed_to_load_booking','Failed to load booking.'));
        }
    }
}

$(document).ready(()=> new ConfirmationApi());
